import React from 'react';

import { Box, Text } from '@rbilabs/universal-components';
import { TWELVE_HOUR_TIME_PARSE_FORMAT } from 'features/store/constants';
import { readableHour } from 'features/store/utils';

import { IServerOrder } from '@rbi-ctg/menu';
import useOrderNumber from 'hooks/use-order-number';
import { t } from 'state/intl/translations';
import { getConfigValue } from 'utils/environment';

import { CardHeading, CardHeadingContainer, CardText } from '../styled';

interface IDeliveryOrderDetails {
  serverOrder: IServerOrder;
}

const DeliveryOrderDetails = ({ serverOrder }: IDeliveryOrderDetails) => {
  const orderNumber = useOrderNumber(serverOrder);
  const cardType = serverOrder?.cart?.payment?.cardType || null;
  const ccLast4 = serverOrder?.cart?.payment?.ccLast4 || null;

  const timeFormatConfig = getConfigValue({
    key: 'timeFormat',
    defaultValue: TWELVE_HOUR_TIME_PARSE_FORMAT,
  });

  const isCashApp = cardType === 'CASHAPP';

  return (
    <CardHeadingContainer>
      <CardHeading>{t('orderDetailsHeading')}</CardHeading>

      <Box marginTop="$4">
        {orderNumber ? (
          <CardText>
            <Text fontWeight="bold">{t('orderNumber')}: </Text>
            {orderNumber}
          </CardText>
        ) : null}
        {cardType && ccLast4 && !isCashApp && (
          <CardText>
            <Text fontWeight="bold">{t('payment')}: </Text>
            {t('paymentXEndingInY', {
              cardType,
              ccLast4,
            })}
          </CardText>
        )}
        {isCashApp && (
          <CardText>
            <Text fontWeight="bold">{t('payment')}: </Text>
            {t('cashAppPay')}
          </CardText>
        )}
        <CardText>
          <Text fontWeight="bold">{t('orderTime')}: </Text>
          {readableHour({
            timeISOString: serverOrder.createdAt,
            timeFormat: timeFormatConfig,
          })}
        </CardText>
      </Box>
    </CardHeadingContainer>
  );
};

export default DeliveryOrderDetails;
